import { StateCreator } from 'zustand';

import { filterDefecten } from '@/domain/defecten/defectFilter';

import { LmmDefectenStore } from './types/LmmDefectenStore';

export const lmmDefectenStateCreator: StateCreator<LmmDefectenStore> = (set, _get, _store) => ({
  defecten: [],
  setDefecten(defecten, locaties) {
    set(() => {
      const huidigeLocaties = Object.fromEntries(locaties.map((locatie) => [locatie.eenheidNummer, locatie]));
      defecten = defecten
        .filter(
          filterDefecten({
            active: true,
          }),
        )
        .map((defect) => {
          if (huidigeLocaties?.[defect.eenheidNummer]?.dienstregelpunt)
            defect.huidigeLocatie = huidigeLocaties[defect.eenheidNummer];
          return defect;
        });
      return { defecten };
    });
  },
});
